import React from 'react';
import PropTypes from 'prop-types';
import { AdSlot } from "react-dfp";

export const DFPAdvert = (props) => {
    return (
        <div style={{textAlign: 'center'}}>
            <AdSlot sizes={props.sizes}/>
        </div>
    );
};

DFPAdvert.propTypes = {
    sizes: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/DFPAdvert.js